<template>
  <div
    class="absolute bottom-3 left-0 right-0 z-10 mx-auto flex w-[244px] flex-row items-center justify-between"
  >
    <button type="button" class="cursor-pointer" :aria-label="prevLabel" @click="slidePrev()">
      <SliderArrowLeft aria-hidden="true" />
    </button>
    <button type="button" class="cursor-pointer" :aria-label="nextLabel" @click="slideNext()">
      <SliderArrowRight aria-hidden="true" />
    </button>
  </div>
</template>

<script setup lang="ts">
import SliderArrowLeft from '../atoms/Icons/SliderArrowLeft.vue'
import SliderArrowRight from '../atoms/Icons/SliderArrowRight.vue'

// TestimonialBlock's carousel.
interface Slider {
  slideNext(speed?: number): void
  slidePrev(speed?: number): void
}

const props = withDefaults(
  defineProps<{ slider?: Slider; prevLabel?: string; nextLabel?: string }>(),
  { slider: undefined, prevLabel: 'Föregående', nextLabel: 'Nästa' },
)

const slideNext = () => {
  props.slider?.slideNext(500)
}
const slidePrev = () => {
  props.slider?.slidePrev(500)
}
</script>
